export function fbSetup (doc, s, id) {
  if (doc.getElementById(id)) {
    return
  }
  const fjs = doc.getElementsByTagName(s)[0]
  const js = doc.createElement(s)
  js.id = id
  js.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.10 '
  fjs.parentNode.insertBefore(js, fjs)
}

export function twitterSetup (doc, s, id) {
  const t = window.twttr || {}
  if (doc.getElementById(id)) {
    return t
  }
  const fjs = doc.getElementsByTagName(s)[0]
  let js = doc.createElement(s)
  js.id = id
  js.src = 'https://platform.twitter.com/widgets.js'
  fjs.parentNode.insertBefore(js, fjs)

  t._e = []
  t.ready = function (f) {
    t._e.push(f)
  }

  return t
}

export const emailAddr = 'joeteibel@gmail.com'
export const mailToEmailAddr = `mailto:${emailAddr}`



// WEBPACK FOOTER //
// ./src/components/social.js